<template>
  <div>
    <b-col v-if="Productfinder" :md="Productfinder ? '6' : '4'" sm="12">
      <b-card footer-tag="footer" class="h-100 shop-card pb-0">
        <p class="custom-btn-top px-4 py-1">New Arrival</p>
        <p class="custom-btn-right px-4 py-1">{{productDetail.learning[0].skill_name}}</p>
        <!-- <p class="custom-btn-right-2 px-4 py-1">{{productDetail.learning[0].skill_name}}</p> -->
        <a :href="'https://www.avishkaar.cc/course/' + productDetail.course_code">
          <div class="img-card d-flex flex-wrap align-items-center justify-content-center overflow-hidden">
            <img :src="productDetail.course_image" alt="">
          </div>
        </a>
        <div class="title-bg h-100 px-4">
          <!-- <div class="ratings">
            <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.98125 0.394531L10.934 6.41816H17.2533L12.1409 10.141L14.0937 16.1646L8.98125 12.4418L3.86881 16.1646L5.82159 10.141L0.709147 6.41816H7.02847L8.98125 0.394531Z" fill="#FCAC31"/>
            </svg>
            <span>4.6</span>
          </div> -->
          <h2 class="card-title-custom"><strong>{{productDetail.course_name}}</strong></h2>
        </div>
        <template #footer>
            <div class="col-12 mb-4 px-0">
              <span class="sale-price"><strong>₹ {{productDetail.sale_price}}/-</strong></span> <span class="base-price pl-3"><del>₹ {{productDetail.total_price}}/-</del></span>
            </div>
            <div class="d-flex flex-wrap">
              <!-- <button class="col-2 ab-btn-none px-0">
                  <svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.6635 9.32296H13.838V6.0539H17.0997V3.87453H13.838V0.605469H11.6635V3.87453H8.40185V6.0539H11.6635V9.32296ZM7.31462 19.1301C6.73792 19.1301 6.18484 19.3598 5.77705 19.7685C5.36926 20.1772 5.14017 20.7315 5.14017 21.3095C5.14017 21.8875 5.36926 22.4419 5.77705 22.8506C6.18484 23.2593 6.73792 23.4889 7.31462 23.4889C7.89133 23.4889 8.44441 23.2593 8.8522 22.8506C9.25998 22.4419 9.48908 21.8875 9.48908 21.3095C9.48908 20.7315 9.25998 20.1772 8.8522 19.7685C8.44441 19.3598 7.89133 19.1301 7.31462 19.1301ZM18.1869 19.1301C17.6102 19.1301 17.0571 19.3598 16.6493 19.7685C16.2415 20.1772 16.0124 20.7315 16.0124 21.3095C16.0124 21.8875 16.2415 22.4419 16.6493 22.8506C17.0571 23.2593 17.6102 23.4889 18.1869 23.4889C18.7636 23.4889 19.3167 23.2593 19.7245 22.8506C20.1323 22.4419 20.3614 21.8875 20.3614 21.3095C20.3614 20.7315 20.1323 20.1772 19.7245 19.7685C19.3167 19.3598 18.7636 19.1301 18.1869 19.1301ZM7.49945 15.5887L7.53207 15.4579L8.51058 13.6817H16.6104C17.4258 13.6817 18.1434 13.2349 18.5131 12.5593L22.7098 4.92063L20.818 3.87453H20.8071L19.6112 6.0539L16.6104 11.5023H8.97808L8.83674 11.2081L6.40135 6.0539L5.36849 3.87453L4.34649 1.69516H0.79126V3.87453H2.96571L6.87973 12.1453L5.41198 14.815C5.23802 15.1201 5.14017 15.4797 5.14017 15.8611C5.14017 16.4391 5.36926 16.9934 5.77705 17.4021C6.18484 17.8108 6.73792 18.0405 7.31462 18.0405H20.3614V15.8611H7.77126C7.62992 15.8611 7.49945 15.7412 7.49945 15.5887Z" fill="#606060"/>
                  </svg>
              </button> -->
              <a :href="'https://www.avishkaar.cc/course/' + productDetail.course_code" class="col-12 ml-auto ab-btn text-center">Know More</a>
            </div>
        </template>
      </b-card>
    </b-col>
    <div class="h-100" v-else-if="productDetail">
      <b-card footer-tag="footer" class="h-100 shop-card pb-0">
        <p v-if="productDetail.best_seller==='yes'" class="custom-btn-top px-4 py-1">{{productDetail.product_set_as}}</p>
        <p :style="{color: '#'+productDetail.skill_data.skill_color, 'border-color': '#'+productDetail.skill_data.skill_color}" class="custom-btn-right px-4 py-1">{{productDetail.skill_data.skill_name}}</p>
        <p class="custom-btn-right-2 px-4 py-1">{{productDetail.age}}+ Ages</p>
        <div style="position: relative;" class="img-card d-flex flex-wrap align-items-center justify-content-center overflow-hidden">
          <router-link :to="'/courses/'+productDetail.course_code">
            <img :src="productDetail.shop_thumbnail" alt="Course Thumbnail">
          </router-link>
          <div class="course-heart">
            <svg width="23" height="19" viewBox="0 0 23 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="path-1-inside-1" fill="white">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M20.4164 2.24539C22.6177 4.47494 22.5949 8.0669 20.3653 10.2683L11.9938 18.534C11.8721 18.6541 11.7273 18.7367 11.574 18.7818C11.2051 18.9447 10.7582 18.8735 10.458 18.5695L2.19229 10.1979C-0.00906773 7.96837 0.0137822 4.37641 2.24333 2.17505C4.47288 -0.0263123 8.06484 -0.0034607 10.2662 2.22609L11.3005 3.27358L12.3935 2.19435C14.623 -0.00700677 18.215 0.0158445 20.4164 2.24539Z"/>
            </mask>
            <path d="M20.3653 10.2683L21.349 11.2645L21.349 11.2645L20.3653 10.2683ZM20.4164 2.24539L21.4126 1.26176L20.4164 2.24539ZM11.9938 18.534L11.0101 17.5378L11.0101 17.5378L11.9938 18.534ZM11.574 18.7818L11.1793 17.4385L11.0917 17.4643L11.0082 17.5012L11.574 18.7818ZM10.458 18.5695L9.46178 19.5531L10.458 18.5695ZM2.19229 10.1979L3.18852 9.21429L3.18852 9.21429L2.19229 10.1979ZM2.24333 2.17505L3.22696 3.17128L2.24333 2.17505ZM10.2662 2.22609L9.26997 3.20972L10.2662 2.22609ZM11.3005 3.27358L10.3042 4.25721L11.2879 5.25344L12.2841 4.26981L11.3005 3.27358ZM12.3935 2.19435L11.4099 1.19813L12.3935 2.19435ZM21.349 11.2645C24.1287 8.51989 24.1572 4.04151 21.4126 1.26176L19.4201 3.22903C21.0783 4.90837 21.061 7.61392 19.3817 9.27204L21.349 11.2645ZM12.9774 19.5302L21.349 11.2645L19.3817 9.27204L11.0101 17.5378L12.9774 19.5302ZM11.9686 20.125C12.3385 20.0163 12.687 19.8169 12.9774 19.5302L11.0101 17.5378C11.0571 17.4914 11.1162 17.4571 11.1793 17.4385L11.9686 20.125ZM11.0082 17.5012C11.1536 17.437 11.3326 17.4627 11.4542 17.5858L9.46178 19.5531C10.1838 20.2843 11.2565 20.4525 12.1397 20.0624L11.0082 17.5012ZM11.4542 17.5858L3.18852 9.21429L1.19607 11.1816L9.46178 19.5531L11.4542 17.5858ZM3.18852 9.21429C1.5304 7.53494 1.54762 4.82939 3.22696 3.17128L1.2597 1.17882C-1.52005 3.92343 -1.54854 8.4018 1.19607 11.1816L3.18852 9.21429ZM3.22696 3.17128C4.90631 1.51316 7.61186 1.53037 9.26997 3.20972L11.2624 1.24246C8.51782 -1.53729 4.03945 -1.56578 1.2597 1.17882L3.22696 3.17128ZM9.26997 3.20972L10.3042 4.25721L12.2967 2.28995L11.2624 1.24246L9.26997 3.20972ZM11.4099 1.19813L10.3168 2.27736L12.2841 4.26981L13.3771 3.19058L11.4099 1.19813ZM21.4126 1.26176C18.668 -1.51799 14.1896 -1.54648 11.4099 1.19813L13.3771 3.19058C15.0565 1.53247 17.762 1.54968 19.4201 3.22903L21.4126 1.26176Z" fill="#909090" mask="url(#path-1-inside-1)"/>
            </svg>
          </div>
        </div>
        <div class="title-bg h-100 px-4">
          <div class="ratings">
            <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.98125 0.394531L10.934 6.41816H17.2533L12.1409 10.141L14.0937 16.1646L8.98125 12.4418L3.86881 16.1646L5.82159 10.141L0.709147 6.41816H7.02847L8.98125 0.394531Z" fill="#FCAC31"/>
            </svg>
            <span><strong>4.6</strong></span>
          </div>
           <router-link :to="'/courses/'+productDetail.course_code">
              <h2 class="card-title-custom card-title-custom-w-small"><strong>{{productDetail.course_name}}</strong></h2>
            </router-link>
          <b-card-text class="card-text-custom">{{productDetail.tag_line}}</b-card-text>
        </div>
        <template #footer>
            <div class="col-12 px-0">
              <p style="color: #979797;" class="m-0"><small>Starting from</small></p>
              <span class="sale-price"><strong>₹ {{price}}/-</strong></span> 
            </div>
            <!-- <button class="my-2 ab-btn btn-block">Know More</button> -->
            <router-link class="my-2 ab-btn btn-block text-center" :to="'/courses/'+productDetail.course_code">Know More</router-link>
            <!-- <div class="d-flex flex-wrap">
              <button class="col-2 ab-btn-none px-0">
                  <svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.6635 9.32296H13.838V6.0539H17.0997V3.87453H13.838V0.605469H11.6635V3.87453H8.40185V6.0539H11.6635V9.32296ZM7.31462 19.1301C6.73792 19.1301 6.18484 19.3598 5.77705 19.7685C5.36926 20.1772 5.14017 20.7315 5.14017 21.3095C5.14017 21.8875 5.36926 22.4419 5.77705 22.8506C6.18484 23.2593 6.73792 23.4889 7.31462 23.4889C7.89133 23.4889 8.44441 23.2593 8.8522 22.8506C9.25998 22.4419 9.48908 21.8875 9.48908 21.3095C9.48908 20.7315 9.25998 20.1772 8.8522 19.7685C8.44441 19.3598 7.89133 19.1301 7.31462 19.1301ZM18.1869 19.1301C17.6102 19.1301 17.0571 19.3598 16.6493 19.7685C16.2415 20.1772 16.0124 20.7315 16.0124 21.3095C16.0124 21.8875 16.2415 22.4419 16.6493 22.8506C17.0571 23.2593 17.6102 23.4889 18.1869 23.4889C18.7636 23.4889 19.3167 23.2593 19.7245 22.8506C20.1323 22.4419 20.3614 21.8875 20.3614 21.3095C20.3614 20.7315 20.1323 20.1772 19.7245 19.7685C19.3167 19.3598 18.7636 19.1301 18.1869 19.1301ZM7.49945 15.5887L7.53207 15.4579L8.51058 13.6817H16.6104C17.4258 13.6817 18.1434 13.2349 18.5131 12.5593L22.7098 4.92063L20.818 3.87453H20.8071L19.6112 6.0539L16.6104 11.5023H8.97808L8.83674 11.2081L6.40135 6.0539L5.36849 3.87453L4.34649 1.69516H0.79126V3.87453H2.96571L6.87973 12.1453L5.41198 14.815C5.23802 15.1201 5.14017 15.4797 5.14017 15.8611C5.14017 16.4391 5.36926 16.9934 5.77705 17.4021C6.18484 17.8108 6.73792 18.0405 7.31462 18.0405H20.3614V15.8611H7.77126C7.62992 15.8611 7.49945 15.7412 7.49945 15.5887Z" fill="#606060"/>
                  </svg>
              </button>
              <button class="col-9 ml-auto ab-btn">Buy Now</button>
            </div> -->
        </template>
      </b-card>
    </div>
    <div class="h-100" v-else>
      <b-card footer-tag="footer" class="h-100 shop-card pb-0">
        <!-- <p class="custom-btn-right px-4 py-1">Gear</p>
        <p class="custom-btn-right-2 px-4 py-1">9+ Ages</p> -->
        <div class="img-card d-flex flex-wrap align-items-center justify-content-center overflow-hidden">
           <a :href="get_web_path+'/mycourse/'+myCourse.access_code">
            <img :src="myCourse.course_image" alt="">
          </a>
        </div>
        <div class="title-bg h-100 px-4">
          <!-- <div class="ratings">
            <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.98125 0.394531L10.934 6.41816H17.2533L12.1409 10.141L14.0937 16.1646L8.98125 12.4418L3.86881 16.1646L5.82159 10.141L0.709147 6.41816H7.02847L8.98125 0.394531Z" fill="#FCAC31"/>
            </svg>
            <span>4.6</span>
          </div> -->
           <a :href="get_web_path+'/mycourse/'+myCourse.access_code">
              <h2 class="card-title-custom text-left text-capitalize"><strong>{{myCourse.course_name}} </strong></h2>
          </a>
        </div>
        <template #footer>
            <div class="col-12 px-0 text-left pl-1">
              <a :href="get_web_path+'/mycourse/'+myCourse.access_code">
              <p style="color: #F36F2E;font-size: 14px;"><strong>Continue Learning</strong></p>
              </a>
            </div>
            <!-- <div class="d-flex flex-wrap">
              <button class="col-2 ab-btn-none px-0">
                  <svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.6635 9.32296H13.838V6.0539H17.0997V3.87453H13.838V0.605469H11.6635V3.87453H8.40185V6.0539H11.6635V9.32296ZM7.31462 19.1301C6.73792 19.1301 6.18484 19.3598 5.77705 19.7685C5.36926 20.1772 5.14017 20.7315 5.14017 21.3095C5.14017 21.8875 5.36926 22.4419 5.77705 22.8506C6.18484 23.2593 6.73792 23.4889 7.31462 23.4889C7.89133 23.4889 8.44441 23.2593 8.8522 22.8506C9.25998 22.4419 9.48908 21.8875 9.48908 21.3095C9.48908 20.7315 9.25998 20.1772 8.8522 19.7685C8.44441 19.3598 7.89133 19.1301 7.31462 19.1301ZM18.1869 19.1301C17.6102 19.1301 17.0571 19.3598 16.6493 19.7685C16.2415 20.1772 16.0124 20.7315 16.0124 21.3095C16.0124 21.8875 16.2415 22.4419 16.6493 22.8506C17.0571 23.2593 17.6102 23.4889 18.1869 23.4889C18.7636 23.4889 19.3167 23.2593 19.7245 22.8506C20.1323 22.4419 20.3614 21.8875 20.3614 21.3095C20.3614 20.7315 20.1323 20.1772 19.7245 19.7685C19.3167 19.3598 18.7636 19.1301 18.1869 19.1301ZM7.49945 15.5887L7.53207 15.4579L8.51058 13.6817H16.6104C17.4258 13.6817 18.1434 13.2349 18.5131 12.5593L22.7098 4.92063L20.818 3.87453H20.8071L19.6112 6.0539L16.6104 11.5023H8.97808L8.83674 11.2081L6.40135 6.0539L5.36849 3.87453L4.34649 1.69516H0.79126V3.87453H2.96571L6.87973 12.1453L5.41198 14.815C5.23802 15.1201 5.14017 15.4797 5.14017 15.8611C5.14017 16.4391 5.36926 16.9934 5.77705 17.4021C6.18484 17.8108 6.73792 18.0405 7.31462 18.0405H20.3614V15.8611H7.77126C7.62992 15.8611 7.49945 15.7412 7.49945 15.5887Z" fill="#606060"/>
                  </svg>
              </button>
              <button class="col-9 ml-auto ab-btn">Buy Now</button>
            </div> -->
        </template>
      </b-card>
    </div>
  </div>
</template>
<script>
export default {
  name: "CourseCard",
  props: ["productDetail", "Productfinder","myCourse"],
  data(){
    return {
      price: null,
      get_web_path: process.env.VUE_APP_SITE_URL,
    }
  },
  created() {
    this.price = Math.min(...this.productDetail.coursePrices);
  },
  };
</script>
<style scoped>
.shop-card {
  border: 1px solid rgba(48, 48, 48, 0.12);
    /* border-radius: 20px 20px 0px 0px; */
     border-radius: 20px ;
}
.custom-btn-top  {
  position: absolute;
  top: -15px;
  background: #FFFFFF;
  border: 1px solid #00B3D5;
  box-sizing: border-box;
  border-radius: 24px;
  color: #00B3D5;
  left: 20px;
  z-index: 1;
}
.custom-btn-right {
  position: absolute;
  right: -20px;
  top: 20px;
  background: #FFFFFF;
  border: 1px solid #FCAC31;
  box-sizing: border-box;
  border-radius: 24px;
  color: #FCAC31;
  z-index: 1;
}
.custom-btn-right-2 {
  position: absolute;
  right: -20px;
  margin-top: 60px;
  background: #FFFFFF;
  border: 1px solid #EDEDED;
  box-sizing: border-box;
  border-radius: 24px;
  color: #909090;
  font-size: 12px;
  z-index: 1;
}
.course-heart {
  background-color: #fff;
  /*border: solid 1px #c4c4c4;*/
  height: 40px;
  width: 40px;
  border-radius: 100px;

  display: flex;
  justify-content: space-around;
  align-items: center;

  position: absolute;
  /*z-index: 2;*/
  right: 10px;
  bottom: 10px;
}
.course-heart:hover {
  cursor: pointer;
}

.img-card img {
  width: 100%;
}
.card-title-custom {
  color: #303030;
  font-size: 20px;
  font-family: Roboto;
}
.card-title-custom-w-small {
  width: 88%;
}
.card-text-custom {
  color: #303030;
  font-size: 14px;
  line-height: 18px;
}
.sale-price {
  color: #303030;
  font-weight: 500;
  font-size: 18px;
}
.base-price {
  color: #979797;
  font-size: 14px;
  line-height: 16px;
}
.ratings {
  position: absolute;
  right: 10px;
}
.ratings span {
  position: relative;
  top: 2px;
  color: #303030;
  font-size: 16px;
  padding-left: 6px;
}
.card-footer {
      overflow: hidden;
    border-radius: 0px 0px 20px 20px;
}
.card-footer,
.title-bg {
  border: none !important;
  background: #FBFBFB;
  padding-top: 0px;
}
.title-bg {
  padding: 1.25rem;
}
.card-body {
  padding: 0px;
      border-radius: 20px;
  overflow: hidden;
}
@media only screen and (max-width: 900px) {
}
</style>